import React from "react";
import classes from "./StepperElement.module.scss";

/**
 * スタンプラリー進捗要素プロパティ
 */
type StepperElementProps = {
  /** 達成状態 */
  isAchieve: boolean;
  /** 非達成時画像URL */
  unachievedImage: string;
  /** 達成時画像URL */
  achievedImage: string;
  /** 上部テキスト ("2つで"など) */
  topText?: string;
  /** 下部テキスト ("+100pt"など) */
  bottomText?: string;
};

/**
 * スタンプラリー進捗要素コンポーネント
 * @param props スタンプラリー進捗要素プロパティ
 */
const StepperElement: React.FC<StepperElementProps> = (props) => {
  return (
    <div
      className={`${classes.stepperElement} ${
        props.isAchieve ? classes.stepStatusAchieved : ""
      }`}
    >
      <div>{props.topText}</div>
      <img
        src={props.isAchieve ? props.achievedImage : props.unachievedImage}
        alt=""
        className={classes.stepperImage}
      />
      <div className={classes.bottomText}>{props.bottomText}</div>
    </div>
  );
};

export default StepperElement;
